import { createContext } from "react";
const CRFGroupContext = createContext();
export default CRFGroupContext;